module.exports = __webpack_public_path__ + "static/media/report_p.169bd2f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/screens/report_p.png
// module id = 706
// module chunks = 0